import React, { useEffect, useState } from 'react'
import { TextField } from '@mui/material'
import { Button } from '@resiliatech/birdsong'
import { Row, Text, TextFieldContainer } from './FunderSharedGoals.styled'
import { TaskList } from './TaskList'
import { TaskCreationContainer } from './TaskCreation.styled'
import { TaskToCreate } from './constants'

type TaskCreationProps = {
  onDeleteTask: (taskId: string) => void
  onAddTask: (task: TaskToCreate) => void
  tasks: TaskToCreate[]
}

const initialTaskValues = {
  linkText: '',
  linkUrl: '',
  resourceId: '',
  title: '',
}

export const TaskCreation = ({
  onDeleteTask,
  onAddTask,
  tasks,
}: TaskCreationProps) => {
  const [task, setTask] = useState({
    ...initialTaskValues,
    id: crypto.randomUUID(),
  })

  useEffect(
    () => () => {
      setTask({ ...initialTaskValues, id: crypto.randomUUID() })
    },
    []
  )

  const handleUpdateTask = (updates: Record<string, string>) => {
    setTask({ ...task, ...updates })
  }

  const handleAddTask = () => {
    onAddTask(task)
    setTask({ ...initialTaskValues, id: crypto.randomUUID() })
  }

  const hasTasks = !!tasks.length
  const hasTitle = !!task.title
  const hasValidUrlData =
    !!(task.linkUrl && task.linkText) || (!task.linkUrl && !task.linkText)
  const isTaskButtonDisabled = !hasTitle || !hasValidUrlData

  return (
    <TaskCreationContainer>
      <Text>Optionally, add custom tasks to attach to the goal:</Text>
      <Row>
        <Text>Task Title:</Text>
        <TextFieldContainer>
          <TextField
            required
            label='Task Title'
            value={task.title}
            sx={{ minWidth: '700px' }}
            onChange={({ target: { value } }) =>
              handleUpdateTask({ title: value })
            }
          />
        </TextFieldContainer>
      </Row>
      <Row>
        <Text>Task Resource ID:</Text>
        <TextFieldContainer>
          <TextField
            label='Task Resource ID'
            value={task.resourceId}
            sx={{ minWidth: '700px' }}
            onChange={({ target: { value } }) =>
              handleUpdateTask({ resourceId: value })
            }
          />
        </TextFieldContainer>
      </Row>
      <Row>
        <Text>Task Link Text:</Text>
        <TextFieldContainer>
          <TextField
            label='Task Link Text'
            value={task.linkText}
            sx={{ minWidth: '700px' }}
            onChange={({ target: { value } }) =>
              handleUpdateTask({ linkText: value })
            }
          />
        </TextFieldContainer>
      </Row>
      <Row>
        <Text>Task Link URL:</Text>
        <TextFieldContainer>
          <TextField
            label='Task Link URL'
            value={task.linkUrl}
            sx={{ minWidth: '700px' }}
            onChange={({ target: { value } }) =>
              handleUpdateTask({ linkUrl: value })
            }
          />
        </TextFieldContainer>
      </Row>
      <Row>
        <Button
          isDisabled={isTaskButtonDisabled}
          label='Add Task'
          onClick={handleAddTask}
          type='button'
          variant='secondary'
        />
      </Row>
      {hasTasks && <TaskList onDeleteTask={onDeleteTask} tasks={tasks} />}
    </TaskCreationContainer>
  )
}
